/**
 * Sidebar Header Component
 *
 * Logo and collapse toggle for sidebar.
 */

import { PanelLeftClose } from 'lucide-react';
import { cn } from '@/shared/lib';
import { useTranslation } from 'react-i18next';

interface SidebarHeaderProps {
  isCollapsed: boolean;
  onToggle: () => void;
}

export const SidebarHeader = ({ isCollapsed, onToggle }: SidebarHeaderProps) => {
  const { t } = useTranslation('navigation');

  return (
    <div
      className={cn(
        'flex items-center h-16 px-4 border-b border-neutral-200 dark:border-neutral-800',
        isCollapsed ? 'justify-center' : 'justify-between'
      )}
    >
      {/* Logo */}
      {!isCollapsed && (
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
            <span className="text-white font-bold text-sm">B</span>
          </div>
          <span className="font-semibold text-neutral-900 dark:text-neutral-100">Bimanova</span>
        </div>
      )}

      {/* Collapsed Logo */}
      {isCollapsed && (
        <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
          <span className="text-white font-bold text-sm">B</span>
        </div>
      )}

      {/* Toggle Button */}
      {!isCollapsed && (
        <button
          onClick={onToggle}
          className="p-1.5 rounded-lg text-neutral-500 hover:bg-neutral-100 dark:hover:bg-neutral-800 hover:text-neutral-700 dark:hover:text-neutral-300 transition-colors"
          title={t('sidebar.collapse')}
          aria-label={t('sidebar.collapse')}
        >
          <PanelLeftClose className="w-5 h-5" />
        </button>
      )}
    </div>
  );
};

export default SidebarHeader;
